"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var forms_1 = require("@angular/forms");
var lang_1 = require("../util/lang");
exports.dateISO = function (control) {
  if (lang_1.isPresent(forms_1.Validators.required(control))) return null;
  var v = control.value;
  return /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/.test(v) ? null : {
    dateISO: true
  };
};
